/**
 * Node globals that wallet SDKs expect at module-evaluation time.
 *
 * Imported first from main.tsx so it runs before any other module. The wallet
 * modules (src/wallets/*) are only ever loaded with `import()` after this has
 * run; vite.config.ts keeps the polyfill out of the lazily-loaded wallet chunks
 * so the core bundle never depends on them statically.
 */
import { Buffer } from 'buffer';

const g = globalThis as { Buffer?: typeof Buffer };
if (!g.Buffer) g.Buffer = Buffer;
